import client from '../helpers/HttpClient';

export const getOrderActivities = (sku) =>
  client.get(`api/activities?order_sku=${sku}`);

export const createActivity = (payload) =>
  client.post('api/activities', payload);
